
import { ORGANIZATION_API } from '../api';

const OrganizationService = {

    getConfig: async (organizationId) => {
        const { data } = await ORGANIZATION_API.get(`settings/${organizationId}`);
        return data;
    },

};

export default OrganizationService;
